import { render } from "./LabelDisclaimer.vue?vue&type=template&id=610c9686&scoped=true"
import script from "./LabelDisclaimer.vue?vue&type=script&lang=js"
export * from "./LabelDisclaimer.vue?vue&type=script&lang=js"

import "./LabelDisclaimer.vue?vue&type=style&index=0&id=610c9686&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610c9686"]])

export default __exports__